import React, {useEffect,useState} from 'react'
import { ROUTE } from '../../route/Route'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import SeoAdd from '../Seo/SeoAdd'
import { useTranslation } from "react-i18next";

function PillarsOfEndeavour() {
    const { t } = useTranslation();
    useEffect(() => {
        window?.scrollTo(0, 0);
        return () => {}
    }, [])
    return (
        <>
        <SeoAdd slug={ROUTE.ENDEVOUR}/>
            <BreadCrumb page={t("pillars_endeavour")} data={{slug: "", path: "#"}}/> 
            <section className="categories about-section pt-3">
				<div className="container mb-5" id="section2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="overview-wrap text-center ">
                                <img src={t("images.endeavor.banner")} className="scale" alt=""/>
                                <div className="headingmains text-center pb-2">
                                    <h1 className="right aos-init pb-2 mt-2 mt-lg-3">{t("pillars_endeavour")}</h1>
                                </div>
                               {/*<p className="text-center dull_heading pb-3">{t("pillars_endeavour_text")}</p>*/}
                                <h4 className="text-center mt-0 mt-lg-2 pb-3">{t("pillars_endeavour_vision")}</h4>
                                <p className="f-16 text-center mb-5 end-text-width" style={{maxWidth: "85%", margin: "0 auto"}}>{t("pillars_endeavour_vision_text")}</p>
                            </div>                 
                    </div>
                </div>           
                <section className="sub-section overview_network mt-lg-5">
                    <div className="sub-section bg-gray home-services end-bg-pad">
                    <div className="container pt-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <img src={t("images.endeavor.mission1")} className="scale" alt=""/>
                            </div>
                            <div className="col-md-6 ">
                                <h4 className="text-left mb-0 py-3">{t("pillars_endeavour_mission")}</h4> 
                                <p>{t("pillars_endeavour_mission_text")}</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>

                <div className="row keybusiness">
                    <div className="col-12 mb-lg-5">
                        <h2 className="head2">{t("endeavour_value")}</h2>
                    </div>
                    <div className="col-12">
                        <div className="values-desk">
                            <img src={t("images.endeavor.value")} />
                        </div>
                        <div className="values-mob">
                            <img src={t("images.endeavor.value_mob")} />
                        </div> 
                    </div>
                </div>
                </div>
            </section>
        </>
    )
}

export default PillarsOfEndeavour
